import type { ContextuneSnapshot } from "../types.js";
import { toJson } from "./json.js";
import { toToon } from "./toon.js";

export type { SnapshotFormat } from "../types.js";

export function formatSnapshot(snap: ContextuneSnapshot, format: 'json' | 'toon'): string {
  if (format === 'json') return toJson(snap);
  return toToon(snap);
}
